export const styles = {
  select: (theme) => ({
    borderRadius: "8px",
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
    height: 40,
    maxWidth: "100%",
    "& .MuiSelect-select": {
      py: 0,
      height: 40,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      overflow: "hidden",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
      borderWidth: 1,
    },
  }),
  placeholder: (theme) => ({
    color: theme.palette.text.disabled,
  }),
  valueText: (theme) => ({
    color: theme.palette.text.primary,
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
  menuItemText: (theme) => ({
    color: theme.palette.text.primary,
  }),
  menuProps: {
    disableScrollLock: true,
    BackdropProps: {
      sx: {
        backgroundColor: "transparent !important",
      },
    },
  },
  loadingIndicator: {
    display: "flex",
    alignItems: "center",
    mr: 2,
  },
}
